


















import { defineComponent } from '@nuxtjs/composition-api';
import AppOptimizedImage from '~/components/partials/App/AppOptimizedImage.vue';

const PICKUP_ITEMS = [
  {
    image: {
      sp: require('~/assets/images/top/satisfaction-free-shipping-sp.svg'),
      pc: require('~/assets/images/top/satisfaction-free-shipping-pc.svg'),
    },
    alt: '１万円以上で送料無料',
  },
  {
    image: {
      sp: require('~/assets/images/top/satisfaction-assortment-sp.svg'),
      pc: require('~/assets/images/top/satisfaction-assortment-pc.svg'),
    },
    alt: '常時2000種類 国内最大級の品揃え',
  },
  {
    image: {
      sp: require('~/assets/images/top/satisfaction-shipping-sp.svg'),
      pc: require('~/assets/images/top/satisfaction-shipping-pc.svg'),
    },
    alt: '朝9時までのご注文は最短当日出荷',
  },
  {
    image: {
      sp: require('~/assets/images/top/satisfaction-point-sp.svg'),
      pc: require('~/assets/images/top/satisfaction-point-pc.svg'),
    },
    alt: 'ショップでもオンラインでもポイント還元',
  },
  {
    image: {
      sp: require('~/assets/images/top/satisfaction-first-order-sp.svg'),
      pc: require('~/assets/images/top/satisfaction-first-order-pc.svg'),
    },
    alt: 'オンライン 初めてのご注文は送料無料',
  },
  {
    image: {
      sp: require('~/assets/images/top/satisfaction-shop-sp.svg'),
      pc: require('~/assets/images/top/satisfaction-shop-pc.svg'),
    },
    alt: '全国に60店舗以上のワインショップ',
  },
];

export default defineComponent({
  components: {
    AppOptimizedImage,
  },
  setup() {
    return {
      PICKUP_ITEMS,
    };
  },
});
